import React from 'react';

interface DetailsItemProps {
  title: string;
  value: string;
  id?: string;
  card?: boolean;
  children?: any;
  onClick?: () => void;
}

const DetailsItem: React.FC<DetailsItemProps> = ({
  title,
  value,
  id,
  card,
  children,
}) => {
  return (
    <>
      {value !== '0' && (
        <div className="detailsItem tableFilterCard" id={id}>
          {card ? (
            <>
              <p>{value}</p>
              <p>{title}</p>
              {children}
            </>
          ) : (
            <>
              <p>{title}</p>
              <p>{value}</p>
            </>
          )}
        </div>
      )}
    </>
  );
};

export default DetailsItem;
